<template>
  <div class="_side_navigation_container">
    <div class="collapse_icon">
      <i  :class="[isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold']"
          @click="isCollapse = !isCollapse"></i>
    </div>
    <el-scrollbar class="side_content">
      <el-menu  :ref="menu_ref" :default-active="default_active" :default-openeds="default_openeds"
                @open="handleOpen" @close="handleClose" @select="menu_select"
                background-color="#fff" text-color="#666666" menu-trigger="click"
                class="sys_navigation_menu"  :unique-opened="unique_opened" :collapse="isCollapse">
        <template v-for="(firstLevel,index) in navigationList">
          <el-submenu popper-class="sys_navigation_menu" v-if="firstLevel.menuVoList&&firstLevel.menuVoList.length>0" :index="firstLevel.menuUrl"
                      :key="index+Math.random()">
            <template slot="title">
              <!-- <i class="menu_icon"  :class="firstLevel.icon"></i> -->
              <i >
                <div class="menu_icon" 
                    :style='{backgroundImage: "url("+firstLevel.icon+")"}'
                  ></div>
              </i>
              <span slot="title" style="font-size: 16px;font-weight: bold;">{{firstLevel.name}}</span>
            </template>

            <!--2级菜单-->
            <template v-for="(secondLevel,secIndex) in firstLevel.menuVoList">

              <el-submenu v-if="secondLevel.menuVoList&&secondLevel.menuVoList.length>0" :index="secondLevel.menuUrl" :key="secIndex+Math.random()">
                <template slot="title">
                  <span slot="title">{{secondLevel.name}}</span>
                </template>

                <!--                &lt;!&ndash;3级菜单&ndash;&gt;-->
                <el-menu-item v-for="(thirdLevel,thirdIndex) in secondLevel.menuVoList" :key="thirdIndex+Math.random()"
                              :index="thirdLevel.menuUrl" @click="menuClick(thirdLevel)">
                  <span slot="title">{{thirdLevel.name}}</span>
                </el-menu-item>
              </el-submenu>

              <el-menu-item v-else :key="secIndex+Math.random()" :index="secondLevel.menuUrl"
                            @click="menuClick(secondLevel)">
                <span slot="title">{{secondLevel.name}}</span>
              </el-menu-item>

            </template>

          </el-submenu>
          <el-menu-item index="index" v-else @click="menuClick(firstLevel)" :index="firstLevel.menuUrl">
            <!-- <i class="menu_icon " :class="firstLevel.icon"></i> -->
            <i >
              <div class="menu_icon" 
                  :style='{backgroundImage: "url("+firstLevel.icon+")"}'
                ></div>
            </i>
            <span slot="title" style="font-size: 16px;font-weight: bold;">{{firstLevel.name}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  created() {
    this.isCollapse = this.is_collapse
    this.menu_ref = this.get_uuid()
  },
  watch:{
    $route(to,from){
      this.default_active = to.path
      /*
        let res = this.navigationList.find(item => {return item.id == to.path})
        if(res){
          this.default_active = to.path
        }*/
    }
  },
  mounted() {
    this.handle_last_data()
    window.addEventListener("beforeunload", this.handle_beforeunload,false);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handle_beforeunload,false);
  },
  name: "sideNavigation",
  props: {
    is_collapse:{
      default:false,
      type:Boolean
    },
    //没有下级菜单时一定不要有children字段,key作为路由路径,id唯一标识不能重复，下级菜单可以跳转到不同页面,也可以作为参数跳转到同一页面路由配置中设置参数
    navigationList:{
      default:[],
      type:Array
    },
    /*是否只保持一个子菜单的展开*/
    unique_opened:{
      default:true,
      type:Boolean
    }
  },
  data() {
    return {
      menu_ref:"",
      isCollapse:"",
      default_openeds:[],/*默认展开*/
      default_active:"",/*默认激活*/
      default_opends_path_store:[]/*存储展开项*/
    }
  },
  methods: {
    /*处理上次是否有存储的数据*/
    handle_last_data(){
      this.handle_default_menu_by_route()
    },

    /*通过路由处理菜单默认展开项*/
    handle_default_menu_by_route(){
      let route = this.$route.path
      this.default_active = route
    },

    /*处理刷新*/
    handle_beforeunload(){
      let props_arr = ["isCollapse","default_opends_path_store","default_active"]
      /*当前数据*/
      let last_data = {}
      props_arr.forEach(item => {
        last_data[item] = this[item]
      })
      sessionStorage.setItem("sys_menu_component", JSON.stringify(last_data));
    },

    handleOpen(index,indexPath){
      /*如果是只展开一个菜单，记录一个，否则记录一组*/
      if(this.unique_opened){
        this.default_opends_path_store[0] = index
      }else{
        this.default_opends_path_store.push(index)
      }
    },

    handleClose(index,indexPath){
      /*如果是只展开一个菜单，情况存储，否则删除对应存储*/
      if(this.unique_opened){
        this.default_opends_path_store = []
      }else{
        let index_in_opens = this.default_opends_path_store.findIndex(item => item == index)
        if(index_in_opens > -1){
          this.default_opends_path_store.splice(index_in_opens,1)
        }
      }
    },

    /*记录当前选中菜单项*/
    menu_select(index,indexPath){
      this.default_active = index
    },

    /*菜单点击*/
    menuClick(menu_item) {
      this.$emit("menu_click",menu_item.menuUrl,menu_item)
    },

    get_uuid(){
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      var uuid = s.join("");
      return uuid;
    }
  }
}
</script>

<style lang="scss">

$meun_width:200px;/*菜单宽度*/
$collapse_icon_size:25px!important;/*收起按钮字号*/
$icon_size:16px!important;/*菜单icon字号*/
$active_font_color:#00955b!important;/*菜单激活字体颜色*/
$active_back_color: rgba(32,132,237,0.1)!important;/*激活的叶子菜单背景色*/
$active_menu_back_color: rgba(255,255,255,1)!important;/*父菜单hover背景色*/
/*激活的菜单样式*/
@mixin active_item{
  height: 50px;
  line-height: 50px;
  color:$active_font_color;
  background-color: $active_back_color;
}

/*已经菜单即为叶子菜单情况下，收起的时候，hover弹窗的tip*/
/*.el-tooltip__popper{
  background-color: #fff!important;
  color: #000!important;
}*/

/*箭头轮廓颜色*/
.popper__arrow {
  border-right-color: #fff!important;
}

/*箭头颜色*/
.popper__arrow:after {
  border-right-color: #fff!important;
}

/*菜单各种颜色样式，这里要放在外面，为了收起后hover弹出菜单*/
.sys_navigation_menu {
  height: 50px;
  line-height: 50px;
  .menu_icon{
    font-size: $icon_size;
    width: 24px;
    height: 24px;
    display: inline-block;
    margin-top: -6px;
    background-size: contain;
  }

  /*字号*/
  .el-menu-item ,.el-submenu__title{
    height: 50px;
    line-height: 50px;
    font-size: 14px!important;
  }

  /*叶子菜单激活状态的样式*/
  .el-menu-item.is-active{
    @include active_item
    .menu_icon{
      color: $active_font_color;
    }
  }

  /*叶子菜单hover样式*/
  .el-menu-item{
    &:hover{
      @include active_item
      .menu_icon{
        color: $active_font_color;
      }
    }
  }

  /*父菜单hover*/
  .el-submenu__title{
    &:hover{
      color: $active_font_color;
      background-color: $active_menu_back_color;
      .menu_icon{
        color: $active_font_color;
      }
    }
  }

  /*展开的父菜单*/
  .el-submenu.is-active ,.el-submenu.is-opened{
    .el-submenu__title{
      color: $active_font_color;
      .menu_icon{
        color: $active_font_color;
      }
    }
  }

}

._side_navigation_container {
  height: 100%;
  max-width: 200px;
  overflow: hidden;
  background: #fff;

  .collapse_icon {
    text-align: center;
    font-size: $collapse_icon_size;
    line-height: 40px;
    color: #B6C2D6;
  }

  .side_content {
    height: calc(100% - 40px);
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  .side_navigation_content:not(.el-menu--collapse) {
    min-width: 200px;
    background: transparent;
  }

  .side_navigation_content {
    border: none !important;
  }

  .el-menu {
    width: $meun_width;
    border:none!important;
    .el-submenu{
      .el-menu-item{
        padding-left: 50px !important;
      }
    }
  }
  .el-menu--collapse {
    width: 60px;
  }


}
</style>



// WEBPACK FOOTER //
// src/components/sideNavigationNew.vue